export class SetUpPropertyStateError extends Error {

}
